import { render, staticRenderFns } from "./BargainRecord.vue?vue&type=template&id=ccf3d5ba&"
import script from "./BargainRecord.vue?vue&type=script&lang=js&"
export * from "./BargainRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports